<div style="margin-bottom: 10px;">

  <div class="text-area">
    <input type="search" class="input-search" (input)="onSearchTermChange($any($event.target).value)" results
      placeholder="Procure pelo nome de um medicamento listado" [(ngModel)]="medShow">
    <mat-spinner class="spinner" *ngIf="searchingMedications" diameter="20"></mat-spinner>
    <img src="assets/icons/Icon ionic-ios-search.svg" style="margin-right: 5px;">
  </div>

  <div [ngClass]="medicationsSearched.length > 0 ? 'search-results' : 'no-results'" id="style-1">
    <table>
      <tbody>
        <tr *ngFor="let medication of medicationsSearched" style="cursor: pointer;">

          <td [ngStyle]="{'background-color': medication.backgroundColor}" style="width: 1197px;"
            (mouseenter)="changeColor(medication)" (mouseleave)="resetColor(medication)"
            (click)="selectMedication(medication)" [innerHTML]="medication.description | highlightWord: medShow">
        </tr>
      </tbody>
    </table>
  </div>
</div>